// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  TDesktopGetNotificationsCountModel,
  IMappers,
  TDesktopGetNotificationsCountResponse,
  IDesktopGetNotificationsCountResponse,
  IDesktopGetNotificationsCountResponseError,
} from './types';

export const defaultConfig: TDesktopGetNotificationsCountModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'notification-center',
  pathApi: '/v1/desktop/get-notifications-count/',
  responseType: 'json',
} as TDesktopGetNotificationsCountModel;

export function createDesktopGetNotificationsCountModel(): TDesktopGetNotificationsCountModel {
  return {
    ...defaultConfig,
  };
}

export interface IDesktopGetNotificationsCountOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchDesktopGetNotificationsCount<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: IDesktopGetNotificationsCountOptions<TResponse200, TResponse400>): Promise<
  TDesktopGetNotificationsCountResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createDesktopGetNotificationsCountModel(), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IDesktopGetNotificationsCountResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IDesktopGetNotificationsCountResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TDesktopGetNotificationsCountResponse;
}
